// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"122":"3160ee60","296":"0faf0a10"}[chunkId] + ".js";
};